import {
  ListItem,
  Badge,
  Checkbox,
  Paper,
  Stack,
  Box,
  Typography,
  Tooltip,
  IconButton,
  Link,
  Grid,
} from "@mui/material";
import Edit from "@mui/icons-material/Edit";
import ReportProblem from "@mui/icons-material/ReportProblem";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import Checklist from "@mui/icons-material/Checklist";
import ChatIcon from "@mui/icons-material/Chat";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime);

export default function AssetCard(props) {
  return (
    <ListItem style={{ padding: 0 }}>
      <Paper
        elevation={6}
        style={{ width: "100%", marginTop: 10, marginBottom: 10 }}
      >
        <div style={{ padding: 20 }}>
          <Box
            sx={{
              width: "100%",
              height: 10,
              borderRadius: 1,
              bgcolor: props.e.Selected ? "secondary.light" : "primary.light",
              // "&:hover": {
              //   bgcolor: "primary.dark",
              // },
            }}
          />
          <Grid container spacing={0}>
            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
              <Stack
                direction="row"
                spacing={2}
                sx={{
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <Checkbox
                  id={props.idx}
                  name={props.idx}
                  checked={props.e.Selected ? props.e.Selected : false}
                  onChange={props.handleChecked}
                />
                {/* <Typography>{`Name: ${props.e.Name}`}</Typography> */}
                <Link
                  variant="h6"
                  gutterBottom
                  underline="hover"
                  href={`/project/${props.projectID}/equipment/${props.e.id}`}
                  color="secondary.main"
                >{`Name: ${props.e.Name}`}</Link>
              </Stack>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
              <Stack direction="row" spacing={1}>
                <Typography color="secondary.light">{`System: `}</Typography>
                <Typography>{`${props.e.System}`}</Typography>
              </Stack>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
              <Stack direction="row" spacing={1}>
                <Typography color="secondary.light">{`Space: `}</Typography>
                <Typography>{`${props.e.Space}`}</Typography>
              </Stack>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
              <Stack direction="row" spacing={1}>
                <Typography color="secondary.light">{`Status: `}</Typography>
                <Typography>{`${props.e.Status}`}</Typography>
              </Stack>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
              <Stack
                direction="row"
                spacing={2}
                sx={{
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="caption"
                  gutterBottom
                  color="secondary.light"
                >{`Created By:`}</Typography>
                <Typography
                  style={{ marginLeft: 4 }}
                  variant="caption"
                  gutterBottom
                >
                  {props.e["Created By"]}
                </Typography>
              </Stack>
              <Stack
                direction="row"
                spacing={2}
                sx={{
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="caption"
                  gutterBottom
                  color="secondary.light"
                >{`Created Date:`}</Typography>
                <Typography
                  style={{ marginLeft: 4 }}
                  variant="caption"
                  gutterBottom
                >
                  {`${new Date(
                    props.e["Created Date"].seconds * 1000,
                  ).toLocaleDateString()}
                          
                             (${dayjs(
                               new Date(props.e["Created Date"].seconds * 1000),
                             ).fromNow()})`}
                </Typography>
              </Stack>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
              <Stack
                direction="row"
                spacing={2}
                sx={{
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="caption"
                  gutterBottom
                  color="secondary.light"
                >{`Modified By:`}</Typography>
                <Typography
                  style={{ marginLeft: 4 }}
                  variant="caption"
                  gutterBottom
                >
                  {props.e["Modified By"]}
                </Typography>
              </Stack>
              <Stack
                direction="row"
                spacing={2}
                sx={{
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="caption"
                  gutterBottom
                  color="secondary.light"
                >{`Modified Date:`}</Typography>
                <Typography
                  style={{ marginLeft: 4 }}
                  variant="caption"
                  gutterBottom
                >
                  {`${new Date(
                    props.e["Modified Date"].seconds * 1000,
                  ).toLocaleDateString()}  (${dayjs(
                    new Date(props.e["Modified Date"].seconds * 1000),
                  ).fromNow()})`}
                </Typography>
              </Stack>
            </Grid>
            <Grid
              sx={{
                display: {
                  xs: "none",
                  sm: "none",
                  md: "none",
                  lg: "block",
                  xl: "block",
                },
              }}
              size={{ xs: 12, sm: 6, md: 4, lg: 3 }}
            />
            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
              <Stack
                style={{ paddingTop: 16 }}
                direction="row"
                spacing={1}
                sx={{
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <Tooltip title="Edit">
                  <IconButton
                    aria-label="Edit"
                    size="large"
                    disabled={!props.allowUpdate}
                    onClick={() => props.onEdit(props.e.id)}
                    color={props.e.Selected ? "primary" : "secondary.light"}
                  >
                    {/* <Badge
                                badgeContent={4}
                                color={props.e.Selected ? "secondary" : "secondary"}
                                showZero
                              > */}
                    <Edit fontSize="inherit" />
                    {/* </Badge> */}
                  </IconButton>
                </Tooltip>
                <Tooltip
                  title={`Files (${props.e.fileCount})`}
                  // title={`Checklists (${props.e.Checklists.length})`}
                >
                  <IconButton
                    aria-label="Files"
                    size="large"
                    color={props.e.Selected ? "primary" : "primary.light"}
                    // onClick={() =>
                    //   props.onDetailsClick({
                    //     id: props.e.id,
                    //     focus: "files",
                    //   })
                    // }
                  >
                    <Badge
                      badgeContent={props.e.fileCount}
                      sx={{
                        "& .MuiBadge-badge": {
                          color: "primary.contrastText",
                          backgroundColor: "secondary.light",
                        },
                      }}
                      showZero
                    >
                      <FileCopyIcon fontSize="inherit" />
                    </Badge>
                  </IconButton>
                </Tooltip>
                <Tooltip title={`Comments (${props.e.commentCount})`}>
                  <IconButton
                    aria-label="Comments"
                    size="large"
                    color={props.e.Selected ? "primary" : "primary.light"}
                    // onClick={() =>
                    //   props.onDetailsClick({
                    //     id: props.e.id,
                    //     focus: "comments",
                    //   })
                    // }
                  >
                    <Badge
                      badgeContent={props.e.commentCount}
                      sx={{
                        "& .MuiBadge-badge": {
                          color: "primary.contrastText",
                          backgroundColor: "secondary.light",
                        },
                      }}
                      showZero
                    >
                      <ChatIcon fontSize="inherit" />
                    </Badge>
                  </IconButton>
                </Tooltip>

                <Tooltip
                  title={`Checklists (${props.e.checklistCount})`}
                  // title={`Checklists (${props.e.Checklists.length})`}
                >
                  <IconButton
                    aria-label="Checklists"
                    size="large"
                    color={props.e.Selected ? "primary" : "primary.light"}
                  >
                    <Badge
                      badgeContent={props.e.checklistCount}
                      sx={{
                        "& .MuiBadge-badge": {
                          color: "primary.contrastText",
                          backgroundColor: "secondary.light",
                        },
                      }}
                      showZero
                    >
                      <Checklist fontSize="inherit" />
                    </Badge>
                  </IconButton>
                </Tooltip>
                <Tooltip
                  title={`Issues (${props.e.issueCount})`}
                  // title={`Issues (${props.e.Checklists.length})`}
                >
                  <IconButton
                    aria-label="Issues"
                    size="large"
                    color={props.e.Selected ? "primary" : "primary.light"}
                  >
                    <Badge
                      badgeContent={props.e.issueCount}
                      // color={props.e.Selected ? "secondary" : "secondary"}
                      showZero
                      sx={{
                        "& .MuiBadge-badge": {
                          color: "primary.contrastText",
                          backgroundColor: "secondary.light",
                        },
                      }}
                    >
                      <ReportProblem fontSize="inherit" />
                    </Badge>
                  </IconButton>
                </Tooltip>
              </Stack>
            </Grid>
          </Grid>
        </div>
      </Paper>
    </ListItem>
  );
}
